// ** UI
import type { Theme } from '@mui/material/styles';

export const DIN = '"DIN Next LT Pro", system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif';

const GlobalStyles = (theme: Theme) => ({
	// Base
	'html, body': {
		minHeight: '100%'
	},
	body: {
		fontFamily: DIN
	},

	// NProgress
	'#nprogress': {
		pointerEvents: 'none',
		'& .bar': {
			left: 0,
			top: 0,
			height: 3,
			width: '100%',
			zIndex: 2000,
			position: 'fixed',
			backgroundColor: theme.palette.primary.main
		}
	},

	// Avatar sizes
	'.profileAvatar': {
		width: '120px !important',
		height: '120px !important'
	},

	// Zoom hover effects
	'.home-news-card-image, .image-grid-card': {
		transition: 'transform 0.3s ease',
		'&:hover': {
			transform: 'scale(1.2)'
		}
	},

	// Neutralize hover
	'.neutralize-hover': {
		'&:hover': {
			color: 'red',
			'& $button': {
				backgroundColor: 'unset',
				filter: 'unset',
				opacity: 'unset'
			}
		}
	},

	// Text formatting utility
	'.textBlock': {
		'& br': {
			display: 'block',
			content: '""',
			marginTop: '3rem',
			lineHeight: '190%',
			verticalAlign: 'top'
		}
	},

	// Slick thumbnails
	'.slick-dots.slick-thumb': {
		display: 'flex !important',
		justifyContent: 'center',
		gap: 8,
		bottom: '-70px',
		position: 'relative'
	},

	'.slick-dots.slick-thumb li': {
		width: 'auto',
		height: 'auto'
	},

	'.slick-dots.slick-thumb li a': {
		display: 'block'
	},

	'.slick-dots.slick-thumb li img': {
		width: 100,
		height: 75,
		objectFit: 'cover',
		borderRadius: 4,
		border: '2px solid transparent',
		transition: 'border-color 0.2s ease'
	},

	/* Highlight active thumbnail */
	'.slick-dots.slick-thumb li.slick-active img': {
		borderColor: theme.palette.primary.main
	}
});

export default GlobalStyles;
